import { ImageScaleView, ViewOpts } from '@play-co/timestep-core/ui';
import { LangBitmapFontTextShadowView } from 'src/lib/ui/components/LangBitmapFontTextShadowView';
import i18n from 'src/lib/i18n/i18n';
import gsap from 'gsap';
import { streakBattleRoyaleTheme } from '../streakbattleroyale.theme';

export default class StreakMessage extends ImageScaleView {
  private message: LangBitmapFontTextShadowView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      image: streakBattleRoyaleTheme().getAsset('message_bg'),
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 37, right: 37 },
      },
      width: 807,
      height: 137,
      centerOnOrigin: true,
      canHandleEvents: false,
    });

    this.message = new LangBitmapFontTextShadowView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      align: 'center',
      verticalAlign: 'center',
      size: 32,
      font: 'Body',
      color: '#FFFFFF',
      localeText: () => i18n('match2.streakBattleRoyale.popup.message'),
      textShadowOffsetX: 0,
      textShadowOpacity: 2,
      canHandleEvents: false,
    });

    this.hideMessage(true);
  }

  public async showMessage(localeText: () => string) {
    await this.hideMessage(true);
    this.updateOpts({ visible: true });
    this.message.localeText = localeText;
    await gsap.to(this.style, {
      duration: 0.25,
      scaleY: 1,
      opacity: 1,
      ease: 'quad.inOut',
      overwrite: true,
    });
  }

  public async hideMessage(instant = false) {
    await gsap.to(this.style, {
      duration: instant ? Number.EPSILON : 0.25,
      scaleY: 0,
      opacity: 0,
      ease: 'quad.inOut',
      overwrite: true,
    });
    this.updateOpts({ visible: false });
  }
}
